// extracted by mini-css-extract-plugin
export default {"L":"1290","M":"950","S":"768","XS":"576"};